// extracted by mini-css-extract-plugin
export default {"container":"FQ-z","title":"GQ-z","link":"HQ-z"};